import { createRouter, createWebHistory } from "vue-router";

// Import components (these will be created next)
const LandingPage = () => import("../views/LandingPage.vue");
const LoginPage = () => import("../views/LoginPage.vue");
const Dashboard = () => import("../views/Dashboard.vue");
const Onboarding = () => import("../views/Onboarding.vue");
const Analytics = () => import("../views/Analytics.vue");
const Generations = () => import("../views/Generations.vue");
const PricingSetup = () => import("../views/PricingSetup.vue");
const ApprovalSettings = () => import("../views/ApprovalSettings.vue");
const MediaUpload = () => import("../views/MediaUpload.vue");

const routes = [
  {
    path: "/",
    name: "landing",
    component: LandingPage,
    meta: { requiresAuth: false },
  },
  {
    path: "/login",
    name: "login",
    component: LoginPage,
    meta: { requiresAuth: false },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/onboarding",
    name: "onboarding",
    component: Onboarding,
    meta: { requiresAuth: true },
  },
  {
    path: "/analytics",
    name: "analytics",
    component: Analytics,
    meta: { requiresAuth: true },
  },
  {
    path: "/generations",
    name: "generations",
    component: Generations,
    meta: { requiresAuth: true },
  },
  {
    path: "/pricing",
    name: "pricing",
    component: PricingSetup,
    meta: { requiresAuth: true },
  },
  {
    path: "/approvals",
    name: "approvals",
    component: ApprovalSettings,
    meta: { requiresAuth: true },
  },
  {
    path: "/media",
    name: "media",
    component: MediaUpload,
    meta: { requiresAuth: true },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const isAuthenticated = localStorage.getItem("token") !== null;

  if (requiresAuth && !isAuthenticated) {
    next("/login");
  } else if (
    (to.name === "login" || to.name === "landing") &&
    isAuthenticated
  ) {
    next("/dashboard");
  } else {
    next();
  }
});

export default router;
